/* Core & libraries */
import React, {useContext, createContext, useState, useEffect} from "react";
import Notification from "../components/notification";

/* Helpers, constants, custom methods, internal libraries */
/* Components */

/* Styles */
import styles from "../components/notification/styles"
import {useTheme} from "react-jss";

const NotificationContext = createContext({});
const NotificationUpdateContext = createContext({});

export function useNotificationContext() {
  return useContext(NotificationContext);
}

export function useNotificationUpdateContext() {
  return useContext(NotificationUpdateContext);
}

export function NotificationProvider({ children }) {

  const theme = useTheme();
  const classes = styles({ theme });

  const [toasts, setToasts] = React.useState([]);

  const setNotification = (type, title, text, singleNotification, dismissTime) => {
    const id = toasts.length + 1;
    const toast = { type, title, text, id, dismissTime };
    setToasts(singleNotification ? [toast] : [...toasts, toast]);
  };


  const removeNotification = id => {
    const newToasts = toasts.filter(t => t.id !== id);
    setToasts(newToasts);
  };

  return (
    <NotificationContext.Provider value={{ setNotification, removeNotification }} displayName="NotificationStore">
      {children}
      <div 
        className={classes.notifiContainer}
        role="region"
        aria-live="polite"
        aria-atomic="true"
      >
        {toasts.map(({ type, title, text, id, ...rest }) => (
          <Notification key={id} removeNotification={()=> removeNotification(id)} type={type} title={title} text={text} rest={rest}/>
        ))}
      </div>
    </NotificationContext.Provider>
  );
}
